import { render, staticRenderFns } from "./Folder.vue?vue&type=template&id=f2dc3908&scoped=true"
var script = {}
import style0 from "./Folder.vue?vue&type=style&index=0&id=f2dc3908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dc3908",
  null
  
)

export default component.exports